import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './index.module.scss';
import GetintouchPng from './img/getintouch.jpg';

import autoBind from 'react-autobind';
import classnames from 'classnames';

import ContactMessage from 'ui/graphql/ContactMessage';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    return (
      <div className={classnames('container')}>
        <img src={GetintouchPng} alt="school" className={classnames(styles.heroImage)} />
        <ContactMessage />
        <div
          className={classnames(
            'justify-content-center align-items-center col-3 col-sm-3',
            styles.rightItems
          )}
        >
          <h4>Email</h4>
          <p>
            <FormattedMessage id="pages.contact.emailid" defaultMessage="info@dataschool.sg" />
          </p>
          <h4>Address</h4>
          <p>
            <FormattedMessage
              id="pages.contact.address"
              defaultMessage="535 Clementi Road, Ngee Ann Polytechnic, The Sandbox, #01-03, Singapore 599489"
            />
          </p>
        </div>
      </div>
    );
  }
}

export default injectIntl(ContactUs);



// WEBPACK FOOTER //
// ./src/ui/pages/contact-us/index.js